interface Props {
  customer: string;
  vendor: string;
  product: string;
  bill_from: string;
  bill_to: string;
  term: string;
  amount: string;
  buy_total: string;
  sell_total: string;
  buy_per: string;
  sell_per: string;
  margin: string;
}

const InvoiceItem = ({
  customer,
  vendor,
  product,
  bill_from,
  bill_to,
  term,
  amount,
  buy_total,
  sell_total,
  buy_per,
  sell_per,
  margin,
}: Props) => {
  return (
    <div className="flex items-center h-16 border-b-2 border-[#f1f4f9] m-3 w-[190vw] text-black text-lg text-center">
      <p className="w-[20vw] ml-[2.5vw] text-left mt-auto mb-auto">
        {customer}
      </p>
      <p className="w-[15vw] my-auto">{vendor}</p>
      <p className="w-[55vw] text-left my-auto">{product}</p>
      <p className="w-[15vw] my-auto">{bill_from}</p>
      <p className="w-[15vw] my-auto">{bill_to}</p>
      <p className="w-[15vw] my-auto">{term}</p>
      <p className="w-[5vw] my-auto">{amount}</p>
      <p className="w-[10vw] my-auto">{buy_total}</p>
      <p className="w-[10vw] my-auto">{sell_total}</p>
      <p className="w-[10vw] my-auto">{buy_per}</p>
      <p className="w-[10vw] my-auto">{sell_per}</p>
      <p className="w-[10vw] my-auto">{margin}</p>
    </div>
  );
};

export default InvoiceItem;
